import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import { faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import './AboutMe.css';

const AboutMe = () => {
  return (
    <div className="about-me-container">
      <h1 className="title">About Me</h1>
      <div className="intro">
      <p>
        I'm Jasper Deasey, a member of the investment team at{' '}
        <a href="https://ubcim.ca/" className="highlight">UBC Investment Management</a>.
        </p>
        <p>
        I created this website to address some of the complex challenges in asset management that I
        encounter regularly. Many of these challenges are common across the industry, so I’ve designed this platform to share solutions that might be helpful for others, too.
        </p>
        <p>
        It’s free and open to everyone; I hope you find it useful.
        </p>

      </div>
      <div className="contacts">
        <h2>Connect with Me</h2>
        <div className="contact-links">
          <a href="mailto:jasperdeasey@gmail.com" className="contact-link">
            <FontAwesomeIcon icon={faEnvelope} /> Email
          </a>
          <a
            href="https://www.linkedin.com/in/jasperdeasey/"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <FontAwesomeIcon icon={faLinkedin} /> LinkedIn
          </a>
          <a
            href="https://github.com/JasperDeasey"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-link"
          >
            <FontAwesomeIcon icon={faGithub} /> GitHub
          </a>
        </div>
      </div>
    </div>
  );
};

export default AboutMe;
